import('@roarr/browser-log-writer');

// eslint-disable-next-line import/first
import { Roarr } from 'roarr';

export const logger = Roarr.child({
  application: 'contra-custom-profiles-web-app',
});
